export default __webpack_public_path__ + "static/media/logo.aa3659a7.png";